import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  useTheme,
  Chip,
} from "@mui/material";
import SunnyIcon from "@mui/icons-material/Sunny";
import BedtimeIcon from "@mui/icons-material/Bedtime";
import ChoosingCurrency from "./ChoosingCurrency";
import Logo from "./Logo";

const Header: React.FC<{
  isDark: boolean;
  setIsDark: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ isDark, setIsDark }) => {
  const theme = useTheme();
  const isPreview = process.env.REACT_APP_UI_PREVIEW === "true";

  return (
    <Box
      component="header"
      width={{ xs: "calc(100% - 24px)", md: "calc(100% - 48px)" }}
      maxWidth="1680px"
      margin="0 auto"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      position="relative"
      zIndex={2}
      sx={{ py: { xs: 1.25, md: 1.75 } }}
    >
      <Box
        display="flex"
        alignItems="center"
        sx={{ gap: { xs: 1, md: 1.5 } }}
      >
        <Box
          sx={{
            display: "grid",
            placeItems: "center",
            borderRadius: "13px",
            overflow: "hidden",
            boxShadow: "0 9px 22px rgba(26, 27, 61, 0.34)",
          }}
        >
          <Logo size={40} />
        </Box>
        <Typography
          sx={{
            fontSize: { xs: "23px", md: "28px" },
            fontWeight: 780,
            letterSpacing: "-0.045em",
            color: theme.palette.text.primary,
          }}
        >
          Finzora
        </Typography>
        <Chip
          label="Merchant"
          size="small"
          sx={{
            display: { xs: "none", sm: "inline-flex" },
            color: "accentText",
            bgcolor: "rgba(99, 91, 255, 0.10)",
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: ".04em",
          }}
        />
        {isPreview && (
          <Chip
            label="PREVIEW"
            size="small"
            sx={{
              display: { xs: "none", md: "inline-flex" },
              color: "text.primary",
              fontSize: 10,
              letterSpacing: ".08em",
            }}
          />
        )}
      </Box>

      <Box display="flex" alignItems="center" gap={0.5}>
        <ChoosingCurrency />
        <Tooltip title={isDark ? "Light theme" : "Dark theme"}>
          <IconButton
            aria-label={
              isDark ? "Switch to light theme" : "Switch to dark theme"
            }
            onClick={() => setIsDark(!isDark)}
            sx={{
              width: 42,
              height: 42,
              color: theme.palette.text.secondary,
              border: `1px solid ${theme.palette.divider}`,
              backgroundColor: theme.palette.background.paper,
            }}
          >
            {isDark ? <SunnyIcon /> : <BedtimeIcon />}
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default Header;
